// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImageSlider.css */

.section7_text-overlay__-tOle {
  position: absolute;
  width: 100%;
  Height: 100%;
  top: 15%;
  left: 0%;
  z-index: 10;  /* 텍스트가 이미지 위에 표시되도록 설정 */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.section7_text-position__Me3LA {
  position: absolute;
  top: 0%;
  width: 87%;
  left: 7%;
}
.section7_text-desc__KEscF {
  color: white;
  padding: 0;
  margin: 0;
  line-height: 1.8;
}

.section7_text-main__gAvIW {
  font-weight: bold;
  color: white;
}


/* 화면 너비가 767px 이하일 때 텍스트 크기 줄이기 */
@media (max-width: 767px) {

  .section7_text-overlay__-tOle {
    top: 10%;
  }


  .section7_text-overlay__-tOle {
    font-size: 64px; /* 작은 화면에서는 텍스트 크기를 고정 */
  }

  .section7_text-desc__KEscF {
    font-size: 15px;
  }
  
  .section7_text-main__gAvIW {
    font-size: 25px;
  }
}

@media (min-width: 768px) and (max-width: 1749px)  {
  
  .section7_text-desc__KEscF {
    font-size: 18px;
  }
  
  .section7_text-main__gAvIW {
    font-size: 30px;
  }
}

/* 화면 너비가 1200px 이상일 때 텍스트 크기 크게 설정 */
@media (min-width: 1750px) {

  .section7_text-desc__KEscF {
    font-size: 18px;
  }
  
  .section7_text-main__gAvIW {
    font-size: 30px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/Sections/section7.module.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,QAAQ;EACR,WAAW,GAAG,yBAAyB;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,QAAQ;AACV;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;;AAGA,kCAAkC;AAClC;;EAEE;IACE,QAAQ;EACV;;;EAGA;IACE,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* ImageSlider.css */\n\n.text-overlay {\n  position: absolute;\n  width: 100%;\n  Height: 100%;\n  top: 15%;\n  left: 0%;\n  z-index: 10;  /* 텍스트가 이미지 위에 표시되도록 설정 */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.text-position {\n  position: absolute;\n  top: 0%;\n  width: 87%;\n  left: 7%;\n}\n.text-desc {\n  color: white;\n  padding: 0;\n  margin: 0;\n  line-height: 1.8;\n}\n\n.text-main {\n  font-weight: bold;\n  color: white;\n}\n\n\n/* 화면 너비가 767px 이하일 때 텍스트 크기 줄이기 */\n@media (max-width: 767px) {\n\n  .text-overlay {\n    top: 10%;\n  }\n\n\n  .text-overlay {\n    font-size: 64px; /* 작은 화면에서는 텍스트 크기를 고정 */\n  }\n\n  .text-desc {\n    font-size: 15px;\n  }\n  \n  .text-main {\n    font-size: 25px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1749px)  {\n  \n  .text-desc {\n    font-size: 18px;\n  }\n  \n  .text-main {\n    font-size: 30px;\n  }\n}\n\n/* 화면 너비가 1200px 이상일 때 텍스트 크기 크게 설정 */\n@media (min-width: 1750px) {\n\n  .text-desc {\n    font-size: 18px;\n  }\n  \n  .text-main {\n    font-size: 30px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text-overlay": `section7_text-overlay__-tOle`,
	"text-position": `section7_text-position__Me3LA`,
	"text-desc": `section7_text-desc__KEscF`,
	"text-main": `section7_text-main__gAvIW`
};
export default ___CSS_LOADER_EXPORT___;
